module.exports = __webpack_public_path__ + "img/33.bc0933b1.jpg";